module.exports = __webpack_public_path__ + "media/images/emblems/Habkern-coat_of_arms-5f93f80e801b31743ef8e1272c8f6435.svg";